import React from 'react'
import moment from 'moment'
import EditIcon from '@material-ui/icons/BorderColorOutlined'
import MoreIcon from '@material-ui/icons/MoreHoriz'
import { Dropdown, DropdownItem, DropdownMenuPosition } from '@duik/it'
import TableRow from '../../UI/TableRow'
import cls from '../../styles/Header.scss'
import NotesIcon from '@material-ui/icons/SpeakerNotesRounded'
import NotesOffIcon from '@material-ui/icons/SpeakerNotesOffOutlined'
import { TwoLineItem, SingleItemBold } from '../../UI/TableItem'

export type Load = {
  _id: string
  driverId: string
  driver: {
    firstName: string
    lastName: string
    companyName: string
    truckId: string
    truckType: string
  }
  material: string
  quantity: string
  arriveTimeA: string
  departTimeA: string
  arriveTimeB: string
  departTimeB: string
  poNumber: string
  haulId: string
  cementBatchSize: string
  cementTotalShipped: string
  cementLocationNumber: string
  cementLocationName: string
  cementTicketNumber: string
  pitGrossWeight: string
  pitNetWeight: string
  pitTareWeight: string
  pitLocationNumber: string
  pitLocationName: string
  pitTicketNumber: string
  pitCompanyName: string
  createdDt: object
  notes: string
  materialConfirmed: boolean
  companyId?: string
  brokerCode?: string
}

export type Props = {
  load: Load
  i: number
  editLoadModalToggle(_id: string): void
  haulDetail: any
  viewNotesModalToggle(_id: string): void
  deleteLoad(_id: string): void
  displayDate: boolean
  handleEditLoad(_id: string, body: Load): void
  companyId: string
}

const LoadItem = (props: Props) => {
  const { load, i, editLoadModalToggle, displayDate, handleEditLoad } = props

  const confirmMaterial = () => {
    handleEditLoad(load._id, {
      ...load,
      materialConfirmed: true
    })
  }

  return (
    <TableRow key={load._id}>
      <TwoLineItem
        text={displayDate ? moment(load.arriveTimeA).format('MMM DD') : ''}
        subText={displayDate ? moment(load.arriveTimeA).format('YYYY') : ''}
        width="12"
      />
      <td style={{ paddingRight: '10px' }}>
        <span style={{ fontSize: '14px', fontWeight: 500 }}>{i}</span>
      </td>
      <TwoLineItem
        text={moment(load.arriveTimeA).format('HH:mm')}
        subText={props.haulDetail.pickUpSite.siteName}
      />
      <TwoLineItem
        text={
          load.arriveTimeB !== null && load.arriveTimeB.length > 0
            ? moment(load.arriveTimeB).format('HH:mm')
            : '-'
        }
        subText={props.haulDetail.dropOffSite.siteName}
      />
      <TwoLineItem
        text={`${load.driver.firstName} ${load.driver.lastName}`}
        subText={load.driver.companyName}
        width="12"
      />
      <TwoLineItem text={load.driver.truckId} subText={load.driver.truckType} width="11" />
      <SingleItemBold
        text={load.arriveTimeB !== null && load.arriveTimeB.length > 0 ? load.quantity : '-'}
        width="11"
      />
      <TwoLineItem
        text={load.material}
        subText={load.materialConfirmed ? 'Confirmed' : 'Click to confirm'}
        hasSublink={!load.materialConfirmed}
        width="11"
        onClick={load.materialConfirmed ? undefined : () => confirmMaterial()}
      />
      <td style={{ textAlign: 'right', width: '17%' }}>
        {props.companyId === load.companyId ? (
          <>
            <div className="tooltip" id="haulIcon">
              <EditIcon onClick={() => editLoadModalToggle(load._id)} className="actionsIcon" />
              <span className="tooltiptext">Edit</span>
            </div>
            {load.notes.length > 0 ? (
              <div className="tooltip" id="haulIcon">
                <NotesIcon
                  className="actionsIcon"
                  onClick={() => props.viewNotesModalToggle(load._id)}
                />
                <span className="tooltiptext">View Notes</span>
              </div>
            ) : (
              <div className="tooltip" id="haulIcon">
                <NotesOffIcon className="actionsIcon" />
                <span className="tooltiptext">No Notes</span>
              </div>
            )}
            <Dropdown
              id="haulIcon"
              className={cls.dropdownFilter}
              ButtonComponent={(props: any) => (
                <MoreIcon className="actionsIcon" onClick={props.handleToggle} />
              )}
              menuPosition={DropdownMenuPosition['bottom-left']}
              closeOnOptionClick
            >
              {/* <DropdownItem onClick={() => console.log('edit')}>Edit</DropdownItem> */}
              <DropdownItem onClick={() => props.deleteLoad(load._id)}>Delete</DropdownItem>
            </Dropdown>
          </>
        ) : null}
      </td>
    </TableRow>
  )
}

export default LoadItem
